var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOcr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.37,
    height: 31.079,
    viewBox: "0 0 79.37 31.079",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27008",
    "data-name": "Group 27008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14075",
    "data-name": "Path 14075",
    d: "M2.627,27.4c0,.979.531,1.855,1.461,1.855s1.468-.863,1.468-1.9c0-.911-.476-1.862-1.461-1.862S2.627,26.39,2.627,27.4Zm3.554-.075a2.145,2.145,0,0,1-2.127,2.412A2.1,2.1,0,0,1,2,27.409,2.175,2.175,0,0,1,4.123,25,2.085,2.085,0,0,1,6.181,27.321Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14076",
    "data-name": "Path 14076",
    d: "M7.2,26.37l.469.707c.123.183.225.353.333.537h.021c.109-.2.218-.367.327-.543l.462-.7h.645L8.33,27.96l1.155,1.7H8.806l-.483-.741c-.129-.19-.238-.373-.353-.571H7.957c-.109.2-.225.373-.347.571l-.476.741H6.475L7.644,27.98,6.529,26.37Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14077",
    "data-name": "Path 14077",
    d: "M10.116,29.659V26.825H9.654V26.37h.462v-.157a1.548,1.548,0,0,1,.38-1.148,1.146,1.146,0,0,1,.8-.306,1.4,1.4,0,0,1,.51.095l-.081.463a.9.9,0,0,0-.381-.075c-.51,0-.639.448-.639.951v.177H11.5v.455h-.795v2.833Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14078",
    "data-name": "Path 14078",
    d: "M12.4,28.021c0,.721.414,1.264,1,1.264s1-.537,1-1.278c0-.557-.279-1.263-.985-1.263S12.4,27.4,12.4,28.021Zm2.609-.034a1.608,1.608,0,0,1-1.638,1.747A1.564,1.564,0,0,1,11.8,28.042a1.606,1.606,0,0,1,1.631-1.747A1.558,1.558,0,0,1,15.011,27.987Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14079",
    "data-name": "Path 14079",
    d: "M15.758,27.4c0-.387-.007-.721-.027-1.026h.523l.02.645H16.3a.988.988,0,0,1,.911-.72.666.666,0,0,1,.17.02v.564a.914.914,0,0,0-.2-.021.839.839,0,0,0-.8.768,1.644,1.644,0,0,0-.027.279v1.753h-.591Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14080",
    "data-name": "Path 14080",
    d: "M20.211,27.708a1.073,1.073,0,0,0-.027-.251.88.88,0,0,0-.863-.693c-.619,0-.985.543-.985,1.271,0,.666.327,1.216.972,1.216a.9.9,0,0,0,.877-.713,1.063,1.063,0,0,0,.027-.259Zm.6-2.875v3.975c0,.292.007.625.027.849H20.3l-.027-.571h-.014a1.215,1.215,0,0,1-1.121.646,1.5,1.5,0,0,1-1.407-1.672A1.573,1.573,0,0,1,19.205,26.3a1.1,1.1,0,0,1,.991.5h.014V24.834Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14081",
    "data-name": "Path 14081",
    d: "M26.449,29.509a2.936,2.936,0,0,1-1.209.217,2.14,2.14,0,0,1-2.263-2.317A2.279,2.279,0,0,1,25.369,25a2.452,2.452,0,0,1,1.087.2l-.143.482a2.157,2.157,0,0,0-.925-.19A1.7,1.7,0,0,0,23.6,27.389a1.665,1.665,0,0,0,1.76,1.841,2.356,2.356,0,0,0,.965-.191Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14082",
    "data-name": "Path 14082",
    d: "M28.9,27.98c-.653-.014-1.393.1-1.393.741a.529.529,0,0,0,.564.571.817.817,0,0,0,.795-.55.622.622,0,0,0,.035-.191Zm.088,1.679-.047-.415h-.021a1.225,1.225,0,0,1-1.006.489.937.937,0,0,1-1.005-.945c0-.795.707-1.23,1.977-1.223V27.5a.678.678,0,0,0-.748-.761,1.642,1.642,0,0,0-.856.244l-.135-.393a2.039,2.039,0,0,1,1.08-.293c1.006,0,1.251.686,1.251,1.345v1.23a4.723,4.723,0,0,0,.054.789Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14083",
    "data-name": "Path 14083",
    d: "M30.426,27.26c0-.34-.007-.619-.027-.89h.523l.027.53h.02A1.134,1.134,0,0,1,32,26.3a.972.972,0,0,1,.931.659h.013a1.362,1.362,0,0,1,.367-.429,1.124,1.124,0,0,1,.727-.231c.435,0,1.08.285,1.08,1.427v1.937h-.584V27.8c0-.632-.231-1.012-.713-1.012a.775.775,0,0,0-.707.543.978.978,0,0,0-.047.3v2.032h-.584V27.688c0-.523-.231-.9-.687-.9a.816.816,0,0,0-.741.6.806.806,0,0,0-.047.292v1.984h-.585Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14084",
    "data-name": "Path 14084",
    d: "M36.679,28.34a1.142,1.142,0,0,0,.027.217.923.923,0,0,0,.9.7c.625,0,1-.509,1-1.264,0-.659-.34-1.223-.979-1.223a.953.953,0,0,0-.911.734,1.143,1.143,0,0,0-.034.244Zm-.619,1.319c.014-.225.027-.557.027-.849V24.834h.591V26.9h.014a1.224,1.224,0,0,1,1.121-.6A1.475,1.475,0,0,1,39.2,27.973a1.563,1.563,0,0,1-1.475,1.76,1.173,1.173,0,0,1-1.1-.619H36.6l-.027.544Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14085",
    "data-name": "Path 14085",
    d: "M39.947,27.4c0-.387-.007-.721-.027-1.026h.523l.02.645h.027a.988.988,0,0,1,.911-.72.665.665,0,0,1,.17.02v.564a.913.913,0,0,0-.2-.021.839.839,0,0,0-.8.768,1.645,1.645,0,0,0-.027.279v1.753h-.591Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27007",
    "data-name": "Group 27007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14086",
    "data-name": "Path 14086",
    d: "M42.189,29.659h.806V26.37h-.806Zm.9-4.213c.009.2-.193.367-.514.367-.283,0-.486-.163-.486-.367s.211-.374.5-.374S43.088,25.235,43.088,25.445Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14087",
    "data-name": "Path 14087",
    d: "M45.982,27.708a1.073,1.073,0,0,0-.027-.251.88.88,0,0,0-.863-.693c-.619,0-.985.543-.985,1.271,0,.666.327,1.216.972,1.216a.9.9,0,0,0,.877-.713,1.063,1.063,0,0,0,.027-.259Zm.6-2.875v3.975c0,.292.007.625.027.849h-.537l-.027-.571h-.014a1.214,1.214,0,0,1-1.121.646A1.5,1.5,0,0,1,43.5,28.062,1.573,1.573,0,0,1,44.977,26.3a1.1,1.1,0,0,1,.991.5h.014V24.834Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14088",
    "data-name": "Path 14088",
    d: "M49.782,27.668a.848.848,0,0,0-.035-.272.86.86,0,0,0-.835-.632c-.571,0-.978.483-.978,1.243,0,.646.326,1.183.971,1.183a.875.875,0,0,0,.829-.611,1.058,1.058,0,0,0,.047-.319Zm.618-1.3c-.013.238-.027.5-.027.9v1.909a1.891,1.891,0,0,1-.469,1.5,1.742,1.742,0,0,1-1.2.395,2.123,2.123,0,0,1-1.094-.272l.15-.455a1.851,1.851,0,0,0,.965.259c.611,0,1.06-.32,1.06-1.149v-.367h-.014a1.172,1.172,0,0,1-1.046.551,1.47,1.47,0,0,1-1.4-1.6,1.579,1.579,0,0,1,1.481-1.747,1.094,1.094,0,0,1,1.026.571h.014l.027-.5Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14089",
    "data-name": "Path 14089",
    d: "M53.444,27.695a.851.851,0,0,0-.829-.972.991.991,0,0,0-.917.972Zm-1.753.428a1.054,1.054,0,0,0,1.129,1.141,2.163,2.163,0,0,0,.911-.169l.1.428a2.658,2.658,0,0,1-1.094.2,1.527,1.527,0,0,1-1.617-1.658,1.6,1.6,0,0,1,1.542-1.774,1.393,1.393,0,0,1,1.359,1.549,2.173,2.173,0,0,1-.02.279Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14090",
    "data-name": "Path 14090",
    d: "M57.922,27.98c-.653-.014-1.393.1-1.393.741a.529.529,0,0,0,.564.571.817.817,0,0,0,.795-.55.618.618,0,0,0,.034-.191Zm.089,1.679-.047-.415h-.021a1.226,1.226,0,0,1-1.006.489.937.937,0,0,1-1.005-.945c0-.795.707-1.23,1.977-1.223V27.5a.678.678,0,0,0-.747-.761,1.642,1.642,0,0,0-.857.244l-.135-.393a2.038,2.038,0,0,1,1.08-.293c1.006,0,1.251.686,1.251,1.345v1.23a4.723,4.723,0,0,0,.054.789Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14091",
    "data-name": "Path 14091",
    d: "M59.461,27.26c0-.34-.007-.619-.027-.89h.53l.035.543h.013A1.21,1.21,0,0,1,61.1,26.3c.456,0,1.162.271,1.162,1.4v1.964h-.6v-1.9c0-.53-.2-.971-.761-.971a.879.879,0,0,0-.843.89v1.977h-.6Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14092",
    "data-name": "Path 14092",
    d: "M65.461,27.708a1.073,1.073,0,0,0-.027-.251.88.88,0,0,0-.863-.693c-.619,0-.985.543-.985,1.271,0,.666.327,1.216.972,1.216a.9.9,0,0,0,.877-.713,1.062,1.062,0,0,0,.027-.259Zm.6-2.875v3.975c0,.292.007.625.027.849h-.537l-.027-.571h-.014a1.215,1.215,0,0,1-1.121.646,1.5,1.5,0,0,1-1.407-1.672A1.573,1.573,0,0,1,64.455,26.3a1.1,1.1,0,0,1,.991.5h.014V24.834Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14093",
    "data-name": "Path 14093",
    d: "M69.091,27.226h.6c.632,0,1.033-.347,1.033-.87,0-.591-.429-.849-1.053-.856a2.47,2.47,0,0,0-.585.054ZM68.5,25.14a6.148,6.148,0,0,1,1.135-.1,1.873,1.873,0,0,1,1.326.374,1.142,1.142,0,0,1,.36.869,1.2,1.2,0,0,1-.863,1.169v.02a1.143,1.143,0,0,1,.673.924,7.22,7.22,0,0,0,.353,1.257h-.611a5.959,5.959,0,0,1-.306-1.094c-.135-.632-.38-.87-.917-.89h-.557v1.984H68.5Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14094",
    "data-name": "Path 14094",
    d: "M72.068,28.938a2.092,2.092,0,0,0,1.06.3c.6,0,.958-.319.958-.782,0-.428-.245-.672-.863-.91-.747-.265-1.209-.653-1.209-1.3A1.319,1.319,0,0,1,73.5,25a2.079,2.079,0,0,1,1.012.224l-.163.483a1.824,1.824,0,0,0-.87-.217c-.625,0-.863.373-.863.686,0,.428.279.639.911.883.775.3,1.169.673,1.169,1.345,0,.707-.524,1.319-1.6,1.319a2.368,2.368,0,0,1-1.169-.293Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14095",
    "data-name": "Path 14095",
    d: "M77.736,27.756l-.449-1.319c-.1-.3-.17-.57-.238-.835h-.013c-.068.272-.143.551-.231.829l-.449,1.325Zm-1.5.462-.476,1.441h-.611l1.556-4.58h.714l1.563,4.58h-.632l-.489-1.441Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14096",
    "data-name": "Path 14096",
    d: "M13.958,2.546c5.17,0,8.663,3.089,8.663,8.3s-3.493,8.3-8.663,8.3S5.3,16.05,5.3,10.842,8.789,2.546,13.958,2.546Zm0,19.137c8.151,0,13.959-4.2,13.959-10.841S22.109,0,13.958,0,0,4.2,0,10.842,5.808,21.682,13.958,21.682Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14097",
    "data-name": "Path 14097",
    d: "M66.939,10.155H61.485V2.739h5.454c4.153,0,5.782,1.514,5.782,3.708S71.093,10.155,66.939,10.155ZM77.3,6.447a5.232,5.232,0,0,0-3.393-4.827A17.207,17.207,0,0,0,66.662.5H57.113V21.179h4.372V12.373h2.243l9.881,8.805H79.37L69.012,12.311a14.14,14.14,0,0,0,4.895-1.036A5.234,5.234,0,0,0,77.3,6.447Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14098",
    "data-name": "Path 14098",
    d: "M44.721,19.021c-5.01-.153-8.876-3.186-8.876-8.181s3.866-8.03,8.876-8.181a12.488,12.488,0,0,1,7.068,1.789l2.272-2.329A19.28,19.28,0,0,0,44.651,0C36.423,0,30.535,4.2,30.535,10.84s5.887,10.838,14.116,10.838a19.29,19.29,0,0,0,9.4-2.112l-2.273-2.328A12.486,12.486,0,0,1,44.721,19.021Z",
    fill: "#132a5e",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcr);
export default __webpack_public_path__ + "static/media/ocr.e39fe6fab8430edaba91219b2dfa3504.svg";
export { ForwardRef as ReactComponent };